var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterWhiteOutilneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.773 11.599C8.791 11.615 8.808 11.63 8.825 11.648C9.904 12.754 10.499 14.219 10.499 15.774V19.758L12.735 18.54C12.911 18.444 13.02 18.256 13.02 18.049V15.762C13.02 14.213 13.609 12.753 14.678 11.653L19.515 6.508C19.828 6.175 20 5.738 20 5.277V4.341C20 3.877 19.634 3.5 19.186 3.5H4.315C3.866 3.5 3.5 3.877 3.5 4.341V5.277C3.5 5.738 3.672 6.175 3.985 6.507L8.773 11.599ZM10.146 21.501C9.944 21.501 9.744 21.447 9.562 21.339C9.21 21.129 8.999 20.758 8.999 20.346V15.774C8.999 14.639 8.576 13.57 7.805 12.751C7.782 12.732 7.759 12.711 7.739 12.689L2.893 7.536C2.317 6.924 2 6.121 2 5.277V4.341C2 3.05 3.039 2 4.315 2H19.186C20.461 2 21.5 3.05 21.5 4.341V5.277C21.5 6.12 21.183 6.922 20.609 7.535L15.762 12.689C14.959 13.517 14.52 14.606 14.52 15.762V18.049C14.52 18.805 14.111 19.497 13.453 19.857L10.692 21.361C10.52 21.454 10.333 21.501 10.146 21.501Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhiteOutilneIcon);
export default __webpack_public_path__ + "static/media/filter-white-outilne-icon.9e6bc7c33d693d900edeab9a8ee88a9d.svg";
export { ForwardRef as ReactComponent };